import React, {useCallback, useContext, useEffect, useMemo, useState} from 'react';
import InputForm from "../../../../../components/input/input-form.jsx";
import Button from "../../../../../components/button/button.jsx"
import {FaEraser} from "react-icons/fa";
import {useQuery} from "@tanstack/react-query";
import pointLayerService from "../../../../../services/web/point-layer-service.js";
import {PointLayerContext} from "../point-layer-context.jsx";

const API_URL = import.meta.env.VITE_API_URL;

const PanelIcons = ({showPanel, setShowPanel}) => {
    const {setIsLoading, icons, setIcons, setIconSelected} = useContext(PointLayerContext)
    const [search, setSearch] = useState("")
    const [filteredIcons, setFilteredIcons] = useState([]);

    const normalize = (str = '') => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();

    const { data, status, isLoading } = useQuery({
        queryFn: () =>  pointLayerService.getIcons().then(({data}) => data),
        queryKey: ['icons'],
        enabled: showPanel
    });

    useEffect(() => {
        if (status === "success" && data) {
            setIcons(data);
            setFilteredIcons(data);
        }
    }, [data, status, setIcons]);

    useEffect(() => {
        setIsLoading(isLoading)
    }, [isLoading]);

    const preparedList = useMemo(() => {
        return icons.map(item => ({
            ...item,
            _search: normalize(item.name),
        }));
    }, [icons]);

    const searchItems = useCallback((value) => {
        const searchValue = normalize(value);
        if (!searchValue) return icons;

        const result = [];
        for (const item of preparedList) {
            if (item._search.includes(searchValue)) {
                result.push(item);
                if (result.length === 20) break;
            }
        }
        return result;
    }, [preparedList, icons]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setFilteredIcons(searchItems(search));
        }, 300);

        return () => clearTimeout(timer);
    }, [search, searchItems]);

    const clear = () => {
        setSearch('');
        setFilteredIcons(icons);
    }

    const selectIcon = (icon) => {
        setIconSelected(icon)
        setShowPanel(false)
    }

    return (
        <>
            <div className="grid grid-cols-12 gap-4 mb-2">
                <div className={"col-span-9"}>
                    <InputForm
                        id="search"
                        label="Buscar"
                        value={search}
                        onChange={({target: {value}}) => setSearch(value)}
                    />
                </div>

                <div className={"col-span-3"}>
                    <Button className={"w-full p-0!"} onClick={clear}>
                        <FaEraser />
                    </Button>
                </div>
            </div>

            <div className={"border border-[#c1c1c1] h-[calc(100vh-120px)] overflow-auto"}>
                {
                    filteredIcons.map((point) => {
                        return (
                            <div key={point.id} onClick={() => selectIcon(point)} className={"flex items-center p-1.25 border-b border-[#c1c1c1] cursor-pointer hover:bg-[#e7eaec]"}>
                                <img alt={"icon"}
                                     loading="lazy"
                                    className={"max-h-6.25 mr-1 w-6.25"}
                                    src={`${API_URL}/public/assets/img/markers/customLayers/normal/` + point.marker}
                                />
                                <span className={"font-bold text-xs text-blue-900 truncate"}>{point.name}</span>
                            </div>
                        )
                    })
                }
            </div>

        </>
    );
};

export default PanelIcons;